module.exports = __webpack_public_path__ + "img/P150T_weapon_103.12c03a7e.png";